import { useModelContext } from '@app/contexts/model';
import { useStorageUserConfigContext } from '@app/modules/UserConfig/contexts/storage';
import { Checkbox, List, ListItemButton, ListItemIcon, ListItemText, Typography } from '@mui/material';
import { runInAction } from 'mobx';
import { observer } from 'mobx-react';
import React, { FC } from 'react';

type TProps = {};

export const MainLanguage: FC<TProps> = observer((props: TProps) => {
    const { userConfigStore } = useStorageUserConfigContext();
    const { languageModel } = useModelContext();

    const categoryLangResponse = languageModel.dataCategory.get();

    const handleToggle = (value: string) => () => {
        runInAction(() => {
            if (userConfigStore.mainLanguagesChosenIdSet.includes(value)) {
                userConfigStore.mainLanguagesChosenIdSet.remove(value);
            } else {
                userConfigStore.mainLanguagesChosenIdSet.push(value);
            }
        });
    };

    return (
        <List>
            <Typography>
                Main languages selection <br />
                (select at least one)
            </Typography>
            {categoryLangResponse &&
                categoryLangResponse.main.map((value) => {
                    const labelId = `checkbox-list-label-${value.key}`;
                    return (
                        <ListItemButton key={value.key} role={undefined} onClick={handleToggle(value.key)} dense>
                            <ListItemIcon>
                                <Checkbox edge='start' className={'main-lang'} checked={userConfigStore.mainLanguagesChosenIdSet.includes(value.key)} tabIndex={-1} disableRipple inputProps={{ 'aria-labelledby': labelId }} />
                            </ListItemIcon>
                            <ListItemText id={labelId} primary={`${value.name}`} />
                        </ListItemButton>
                    );
                })}
        </List>
    );
});
